import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { InternalCommonEntityService } from '../service/internal-common-entity-service';
import { CommonEntityVO } from '../entity/common-entity-vo';

@Component({
  selector: 'common-entity-selector',
  templateUrl: './select-common-entity.component.html',
  styleUrls: ['./select-common-entity.component.css']
})
export class SelectCommonEntityComponent{
  @Input() metadataPath: string;
  @Input() filter: string;
  @Input() onlyDisplayCurrentProject: boolean;
  classifier: string;
  @Output() selectorClosed: EventEmitter<any>;
  @Output() commonEntitySelected = new EventEmitter<CommonEntityVO>();

  constructor(private iceService: InternalCommonEntityService) {
    this.selectorClosed = new EventEmitter<any>();
  }


  //éä¸­äºCEï¼ç¹å»ç¡®å®
  confirmCommonEntity() {
    const index = this.iceService.metadatas.length;
    //éä¸­çæ¯å½åå·¥ç¨ä¸çåæ°æ®
    if (this.iceService.metadatas[index - 1].treenode.PackageName === 'default') {
      let ceHeader: CommonEntityVO = this.iceService.getCEHeaderInfo();
      this.commonEntitySelected.emit(ceHeader);
      this.hideModal();
    }
    //éæ©çæ¯åæ°æ®åä¸­çæ°æ® 
    else {
      const index1 = this.iceService.metadatas.length;
      if (index1 > 0) {
        const index2 = this.iceService.metadatas[index1 - 1].treenode.MetadataInfo.length;
        if (index2 > 0) {
          let ceHeader: CommonEntityVO = this.iceService.getCEHeaderFromPkg();
          this.commonEntitySelected.emit(ceHeader);
          this.hideModal();
        }
      }
    }
    // æ¸ç©ºç¼å­
    this.iceService.clearMetadata();
  }

  hideModal(): void {
    this.selectorClosed.emit();
  }
  onSelectedChange(classifier: string) {
    this.classifier = classifier;
  }
}
